export type Priority = 'low' | 'medium' | 'high' | 'critical';
export type Status = 'todo' | 'in-progress' | 'review' | 'done' | 'blocked';

export interface TaskImage {
  id: string;
  task_id: string;
  filename: string;
  original_name: string;
  file_path: string;
  file_size: number;
  content_type: string;
  created_at: string;
  updated_at: string;
}

export interface Task {
  id: string;
  summary: string;
  description: string;
  tag: string;
  priority: Priority;
  labels: string[];
  status: Status;
  videoTutorialTitle: string;
  videoTutorialLink: string;
  owner: string;
  reportedBy: string;
  reportedDate: string;
  expectedDate: string;
  originalEstimate: number; // in hours
  actualTime: number; // in hours
  startDate: string;
  endDate: string;
  workStartedAt?: string;    // Kiedy faktycznie rozpoczęto pracę
  workCompletedAt?: string;  // Kiedy faktycznie zakończono pracę
  images?: TaskImage[];      // Attached images
  createdAt: string;
  updatedAt: string;
}

export interface TaskFilter {
  status?: Status;
  priority?: Priority;
  owner?: string;
  tag?: string;
  label?: string;
}

export interface ExtendedTaskFilter extends TaskFilter {
  search?: string;
  reportedBy?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  expectedDateFrom?: string;
  expectedDateTo?: string;
  reportedDateFrom?: string;
  reportedDateTo?: string;
  originalEstimateMin?: number;
  originalEstimateMax?: number;
  actualTimeMin?: number;
  actualTimeMax?: number;
  isOverdue?: boolean;
  isDueToday?: boolean;
  isDueThisWeek?: boolean;
  hasVideoTutorial?: boolean;
  priorities?: string[];
  labels?: string[];
  sortBy?: 'createdAt' | 'expectedDate' | 'priority' | 'status' | 'summary';
  sortOrder?: 'asc' | 'desc';
}

export interface ColumnStats {
  id: string;
  title: string;
  status: string;
  color: string;
  count: number;
  order: number;
}

export interface TaskStats {
  total: number;
  columns: ColumnStats[];
  overdueCount: number;
}

export interface CreateTaskData {
  summary: string;
  description?: string;
  tag?: string;
  priority?: Priority;
  labels?: string[];
  status?: Status;
  videoTutorialTitle?: string;
  videoTutorialLink?: string;
  owner?: string;
  reportedBy?: string;
  expectedDate?: string;
  originalEstimate?: number;
}

export interface UpdateTaskData extends Partial<CreateTaskData> {
  actualTime?: number;
  startDate?: string;
  endDate?: string;
  workStartedAt?: string;
  workCompletedAt?: string;
}

export const PRIORITIES: Priority[] = ['low', 'medium', 'high', 'critical'];
export const STATUSES: Status[] = ['todo', 'in-progress', 'review', 'done', 'blocked'];

export const PRIORITY_COLORS: Record<Priority, string> = {
  low: '#646669',
  medium: '#e2b714',
  high: '#ff8c42',
  critical: '#ca4754'
};

export const STATUS_COLORS: Record<Status, string> = {
  todo: '#646669',
  'in-progress': '#e2b714',
  review: '#ff8c42',
  done: '#4ade80',
  blocked: '#ca4754'
}; 